function parseDateSafe(value) {
  if (!value) return null;
  const dt = new Date(value);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function getActiveEntitlementEndDate(user, now = new Date()) {
  if (!user) return null;
  const subscriptionEnd = parseDateSafe(user.subscription_expires_at);
  const trialEnd = parseDateSafe(user.trial_ends_at);
  const activeDates = [subscriptionEnd, trialEnd].filter((d) => d && d > now);
  if (!activeDates.length) return null;
  return activeDates.sort((a, b) => b - a)[0];
}

export function userHasActiveEntitlement(user, now = new Date()) {
  const activeByDate = Boolean(getActiveEntitlementEndDate(user, now));
  if (user?.entitlements && typeof user.entitlements.is_premium === "boolean") {
    return Boolean(user.entitlements.is_premium) || activeByDate;
  }
  return activeByDate;
}

export function userHasPaidEntitlement(user, now = new Date()) {
  if (!user) return false;
  const subscriptionEnd = parseDateSafe(user.subscription_expires_at);
  return Boolean(subscriptionEnd && subscriptionEnd > now);
}
